import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="ff-global-footer">
      <div className="container text-center">
        <img src="/fodyfee_logo.png" alt="FodyFee" className="ff-footer-logo" />
        <p className="ff-footer-made-with">
          <i className="fas fa-heart" style={{ color: '#ff5722' }}></i>
          {' '}Made with love from Gilroy, California
        </p>
        <p className="ff-footer-text">
          Powered by <a href="https://fodyfee.com" target="_blank" rel="noopener noreferrer">FodyFee</a>
        </p>
        <div className="ff-footer-links">
          <a href="https://fodyfee.com/terms" target="_blank" rel="noopener noreferrer">Terms</a>
          <a href="https://fodyfee.com/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
